import React, { useState, useEffect } from "react";
import ListaUsuarios from "./ListaUsuarios";
import AreaConversa from "./AreaConversa";
import { listarUsuarios } from "../Services/Chat/usuariosService";

export default function Chat({ usuarioLogado }) {
  const [usuarios, setUsuarios] = useState([]);
  const [usuarioAtivo, setUsuarioAtivo] = useState(null);
  const [historico, setHistorico] = useState({});
  const [carregando, setCarregando] = useState(true);

  // 🔹 Carregar lista de usuários
  useEffect(() => {
    async function carregarUsuarios() {
      try {
        const resposta = await listarUsuarios();

        if (Array.isArray(resposta)) {
          setUsuarios(resposta);
          if (resposta.length > 0) setUsuarioAtivo(resposta[0]);
        } else if (resposta.dados) {
          setUsuarios(resposta.dados);
          if (resposta.dados.length > 0) setUsuarioAtivo(resposta.dados[0]);
        }
      } catch (error) {
        console.error("Erro ao carregar usuários:", error);
      } finally {
        setCarregando(false);
      }
    }

    carregarUsuarios();
  }, []);

  // 🔹 Adiciona nova mensagem no histórico
  const handleNovaMensagem = (usuarioDestino, mensagemObj) => {
    if (!usuarioDestino?.id || !mensagemObj?.texto) return;

    setHistorico((prev) => ({
      ...prev,
      [usuarioDestino.id]: [
        ...(prev[usuarioDestino.id] || []),
        mensagemObj,
      ],
    }));
  };

  // 🔹 Limpa histórico de um usuário (antes de recarregar do banco)
  const limparHistorico = (usuarioId) => {
    setHistorico((prev) => ({
      ...prev,
      [usuarioId]: [],
    }));
  };

  return (
    <div className="flex h-full bg-white rounded-xl overflow-hidden shadow-md border border-gray-200">
      <ListaUsuarios
        usuarios={usuarios}
        usuarioAtivo={usuarioAtivo}
        setUsuarioAtivo={setUsuarioAtivo}
        carregando={carregando}
      />

      {/* Área de conversa */}
      <AreaConversa
        usuarioAtivo={usuarioAtivo}
        historico={historico}
        onNovaMensagem={handleNovaMensagem}
        usuarioLogado={usuarioLogado}
        limparHistorico={limparHistorico} // ✅ passa pro filho
      />
    </div>
  );
}
